import { z } from 'zod';
import { IsoDate, IsoDateTime, Uuid } from '../primitives.js';

/**
 * Query for bookable slots for a service (optionally a specific staff member) on a date.
 * No `.meta({id})` — query schemas must inline as OpenAPI parameters, not $ref components.
 */
export const AvailabilityQuery = z.object({
  serviceId: Uuid,
  date: IsoDate,
  staffId: Uuid.optional(),
  /** Slot granularity in minutes (default 15). */
  granularityMin: z.coerce.number().int().min(5).max(60).default(15),
});
export type AvailabilityQuery = z.infer<typeof AvailabilityQuery>;

export const AvailabilitySlot = z
  .object({
    staffId: Uuid,
    staffName: z.string(),
    startAt: IsoDateTime,
    endAt: IsoDateTime,
  })
  .meta({ id: 'AvailabilitySlot' });
export type AvailabilitySlot = z.infer<typeof AvailabilitySlot>;

export const AvailabilityResult = z
  .object({
    serviceId: Uuid,
    date: IsoDate,
    slots: z.array(AvailabilitySlot),
  })
  .meta({ id: 'AvailabilityResult' });
export type AvailabilityResult = z.infer<typeof AvailabilityResult>;
